import {
    getProduct,
    listProductFeatures
} from './queries';

import {GraphQLQuery,} from '@aws-amplify/api';
import {
    CreateProductFeature,
    DeleteProductFeature,
    GetProductFeature,
    ListProductFeatures,
    ProductFeature,
    UpdateProductFeature,
    EnableProductFeature,
    DisableProductFeature
} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {
    createProductFeature,
    deleteProductFeature,
    updateProductFeature,
    enableProductFeature,
    disableProductFeature
} from "./mutations.ts";
import {ListRecordsQuery} from "../../../types";


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListProductFeatures>>({
                                                                                 query: listProductFeatures,
                                                                                 variables: {
                                                                                     ...query
                                                                                 },
                                                                             });
    return {
        items: response.data?.listProductFeatures.items,
        nextToken: response.data?.listProductFeatures.nextToken
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetProductFeature>>({
                                                                               query: getProduct,
                                                                               variables: {id: id},
                                                                           });
    return response.data?.getProductFeature;
};

export const add = async (payload: Omit<ProductFeature, 'id'>) => {
    const { created: _created, createdByUsername: _createdByUsername, ...createInput } = payload;

    const response = await client.graphql<GraphQLQuery<CreateProductFeature>>({
                                                                                  query: createProductFeature,
                                                                                  variables: {input: createInput},
                                                                              });
    console.debug('in the service response', response);
    return response.data?.createProductFeature;
};

export const update = async (id: string, record: ProductFeature) => {
    const { created: _created, createdByUsername: _createdByUsername, updated: _updated, ...updateInput } = record;

    console.debug('IN UPDATE', id, updateInput);

    const response = await client.graphql<GraphQLQuery<UpdateProductFeature>>({
                                                                                  query: (updateProductFeature),
                                                                                  variables: {input: updateInput},
                                                                              });
    return response.data?.updateProductFeature;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteProductFeature>>({
                                                                                  query: (deleteProductFeature),
                                                                                  variables: {input: {id: id}},

                                                                              });
    return response.data?.deleteProductFeature;
};

export const enableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<EnableProductFeature>>({
        query: enableProductFeature,
        variables: { id }
    });
    return response.data?.activateProductFeature;
};

export const disableRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DisableProductFeature>>({
        query: disableProductFeature,
        variables: { id }
    });
    return response.data?.cancelProductFeature;
};
